import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EllipsisVertical, FileInput, Plus } from "lucide-react";

import AddUser from "./AddUser";
import InviteUser from "./InviteUser";
import { getRandomColor, isAuth, loadStatus } from "../../util";
import Modal from "../../components/modal/Modal";
import { openModal } from "../../features/modalSLice";
import Loading from "../../components/loading/Loading";
import { getUsers, unsetUsers } from "../../features/usersSlice";
import MainContainer from "../../components/container/MainContainer";
import Table from "../../components/tables/Table";
import NetworkError from "../error/NetworkError";
import { useLocation } from "react-router-dom";

const User = () => {
  const [tab, setTab] = useState("table");
  const dispatch = useDispatch();
  const location = useLocation();
  const users = useSelector((state) => state.users.data);
  const user = useSelector((state) => state.user.userInfo);

  const usersPermissions = useSelector((state) => state.user.permissions);

  const loading = useSelector((state) => state.users.load.getUsers);
  const modalContent = useSelector((state) => state.modal.content);

  //Check if its auuthorized to create user
  const isAuthToAddUser = isAuth(usersPermissions, "users", "create");

  //When invite user button is clicked
  const openInviteUserModal = (e) => {
    // e.preventDefault();
    dispatch(openModal(<InviteUser id={user.province_id} />));
  };
  //When Add user button is clicked
  const openAddUserModal = (e) => {
    // e.preventDefault();
    dispatch(openModal(<AddUser id={user.province_id} />));
  };
  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Name" },
    { id: "role", text: "Role" },
    { id: "email", text: "Email" },
    { id: "community", text: "Community" },
    { id: "organization", text: "Organization" },
  ];
  //Get users and clear users if page is closed
  useEffect(() => {
    dispatch(getUsers());
    return () => {
      dispatch(unsetUsers());
    };
  }, []);

  //Loading page if User is being loaded
  if (loading === loadStatus.loading) {
    return <Loading />;
  } else if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} mesage="Network Error" />;
  }

  return (
    <MainContainer className="">
      <Modal>{modalContent}</Modal>
      <div className="flex flex-col">
        <div className="rounded-md text-text-1 py-4 px-4 flex justify-between items-center text-center">
          <h3 className="">Manage Users</h3>
          <div className="flex gap-1.5 items-center justify-center">
            {isAuthToAddUser && (
              <>
                <button
                  className="border-2 border-primary bg-primary text-text-gen p-1 rounded-md"
                  onClick={(e) => openInviteUserModal(e)}
                  disabled={!isAuthToAddUser}
                >
                  <FileInput size={20} />
                </button>
                <button
                  className="border-2 border-primary bg-primary text-text-gen p-1 rounded-md"
                  onClick={(e) => openAddUserModal(e)}
                  disabled={!isAuthToAddUser}
                >
                  <Plus size={20} />
                </button>
              </>
            )}
          </div>
        </div>
        <div className="flex gap-2 mb-5  ">
          <button
            className="px-4 py-1 border-b border-text-1 text-text-1"
            onClick={(e) => setTab("content")}
          >
            Content
          </button>
          <button
            className="px-4 py-1 border-b border-text-1 text-text-1 "
            onClick={(e) => setTab("table")}
          >
            Table
          </button>
        </div>
        {tab === "content" ? (
          <main className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
            {users.map((item, index) => (
              <article key={index} className="bg-content p-5 rounded-xl">
                <div className="flex justify-between items-center pb-4">
                  <h4
                    className={`p-1 px-3 rounded-lg text-text-gen text-sm`}
                    style={{
                      backgroundColor: item.roles?.[0]?.color || "blueviolet",
                    }}
                  >
                    {item.role || "To be Assigned"}
                  </h4>
                  <EllipsisVertical size={20} />
                </div>
                <div className="flex flex-col gap-2 items-center justify-center text-text-1/80">
                  <div
                    className={`w-16 h-16 rounded-full text-center text-3xl ${getRandomColor()} flex items-center justify-center text-text-gen`}
                  >
                    {`${item.first_name[0]}${item.last_name[0]} `}
                  </div>
                  <h3 className="font-semibold text-xl">{`${item.first_name} ${item.last_name}`}</h3>
                  <p className="text-sm p-2">{item.email}</p>
                </div>
                <div className="flex items-center justify-between px-8 py-2 text-text-1/60">
                  <div className="text-center">
                    <h3>5</h3>
                    <p>Projects</p>
                  </div>
                  <div>
                    <h3>30</h3>
                    <p>Tasks</p>
                  </div>
                </div>
              </article>
            ))}
          </main>
        ) : (
          <Table columns={columns} data={users} link />
        )}
      </div>
    </MainContainer>
  );
};

export default User;
